package one.healthium.paywall.ui.models

import one.healthium.domain.paywall.models.ProductDefaults
import one.healthium.payments.models.ProductDetails


data class ProductUiModel(
    private val productDetails: ProductDetails,
    private val defaultsModel: ProductDefaults?
) {
    val id = productDetails.id

    fun period(offerId: String?): String? {
        val isoPeriod = productDetails.period(offerId)
        if (isoPeriod != null) {
            return defaultsModel?.periodsMapping?.get(isoPeriod) ?: isoPeriod
        }
        return null
    }

    fun periodNum(offerId: String?): String? {
        val isoPeriod = productDetails.period(offerId)
        if (isoPeriod != null) {
            return defaultsModel?.periodNumsMapping?.get(isoPeriod) ?: isoPeriod
        }
        return null
    }

    fun price(offerId: String?): String? {
        return productDetails.price(offerId)
    }

    fun priceMonthly(offerId: String?): String? {
        return productDetails.priceMonthly(offerId)
    }

    fun introductoryPrice(offerId: String): String? {
        return productDetails.introductoryPrice(offerId)
    }

    fun introductoryPriceMonthly(offerId: String): String? {
        return productDetails.introductoryPriceMonthly(offerId)
    }
}
